import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CardElement, injectStripe } from 'react-stripe-elements';
import { Button } from '@surfline/quiver-react';
import { CreditCard, Disclaimer, OrBreak } from '../../components';
import config from '../../config';

class OfferForm extends Component {
  createOptions = (fontSize, padding) => ({
    style: {
      base: {
        fontSize,
        color: '#424770',
        letterSpacing: '0.025em',
        fontFamily: 'Source Sans Pro, Helvetica, sans-serif',
        '::placeholder': {
          color: '#aab7c4',
        },
        padding,
      },
      invalid: {
        color: '#9e2146',
      },
    },
  });

  async submitPayment() {
    const {
      paymentHandler,
      triggerSubmit,
      stripe,
      selectedCard,
      showCards,
    } = this.props;
    triggerSubmit();
    const { token = null } = !showCards && await stripe.createToken({ type: 'card' });
    const paymentValues = {
      source: token,
      selectedCard: showCards ? selectedCard : null,
    };
    paymentHandler(paymentValues);
  }

  renderCards = () => {
    const {
      cards,
      selectedCard,
      showCards,
      submitting,
      doSetSelectedCardSource,
    } = this.props;
    if (!cards || !showCards) {
      return (
        <div>
          <OrBreak text="Enter your credit card" />
          <CardElement {...this.createOptions('18px')} disabled={submitting} />
        </div>
      );
    }
    return (
      <div className="credit-card-list">
        <OrBreak text="Select a card" />
        {cards.map((card, index) => (
          <CreditCard
            card={card}
            selectedCard={selectedCard}
            doSetSelectedCardSource={doSetSelectedCardSource}
            tabIndex={index}
            key={card.id}
          />
        ))}
      </div>
    );
  };

  render() {
    const {
      isEligible,
      cards,
      showCards,
      doToggleShowCards,
      submitting
    } = this.props;
    const {
      funnelConfig: { buttonText },
    } = config;
    if (isEligible) {
      return (
        <div className="offer-form">
          <div className="offer-form__cards">
            <div className="credit-card-container">
              {this.renderCards()}
              {cards ? (
                <div>
                  <p
                    onClick={() => doToggleShowCards(showCards)}
                    className="credit-card__form__toggle"
                  >
                    {showCards
                      ? '+ Add New Credit Card'
                      : 'Use An Existing Credit card'}
                  </p>
                </div>
              ) : null}
            </div>
          </div>
          <div className="offer-form__checkout">
            <Button loading={submitting} onClick={() => this.submitPayment()}>
              {buttonText}
            </Button>
          </div>
          <div className="offer-form__disclaimer">
            <Disclaimer referenceText={buttonText} />
          </div>
        </div>
      );
    }
    return null;
  }
}

OfferForm.propTypes = {
  paymentHandler: PropTypes.func.isRequired,
  triggerSubmit: PropTypes.func.isRequired,
  doToggleShowCards: PropTypes.func.isRequired,
  doSetSelectedCardSource: PropTypes.func.isRequired,
  selectedCard: PropTypes.string,
  showCards: PropTypes.bool,
  isEligible: PropTypes.bool,
  submitting: PropTypes.bool,
  cards: PropTypes.arrayOf(PropTypes.shape({})),
};
OfferForm.defaultProps = {
  selectedCard: null,
  showCards: false,
  isEligible: null,
  cards: null,
  submitting: false,
};

export default injectStripe(OfferForm);
